export default __webpack_public_path__ + "ccf3344c4b510308a2f17d82532df9d6.svg";